<template>
  <div class="project" :class="{ 'project-slideable': phone }" :style="style" @click.stop="onClickProject($event)">
    <file class="foo" ref="file" v-for="file in filesRotated" :data-url="file.url" :url="file.url" :landscape="landscape" :key="file.url"></file>
  </div>
</template>

<script>
import EventBus from '../util/EventBus'
import File from './File.vue'
import { tns } from 'tiny-slider/src/tiny-slider.module'

export default {
  name: 'project',
  props: ['uid', 'landscape'],
  components: {
    'file': File
  },
  computed: {
    page () {
      return this.$store.getters.getPageByUID(this.uid)
    },
    phone () {
      return this.$store.state.app.phone
    },
    filesRotated () {
      const times = Math.floor(Math.random() * this.page.files.length)
      return this.rotate(this.page.files.slice(), times)
    }
  },
  data () {
    return {
      slider: null,
      style: {
        height: '100%'
      }
    }
  },
  created () {
    EventBus.$on('lightbox-mouseenter', this.onLightboxMouseEnter)
    EventBus.$on('lightbox-mouseleave', this.onLightboxMouseLeave)
  },
  mounted () {
    let sliderOptions = {
      container: this.$el,
      items: 1,
      slideBy: 'page',
      loop: true,
      speed: 0,
      nav: false,
      mouseDrag: false,
      touch: false,
      controls: false,
      autoHeight: false
    }

    // if (this.landscape) {
    //   sliderOptions.autoplay = true
    //   sliderOptions.autoplayTimeout = 3000
    //   sliderOptions.autoplayHoverPause = true
    //   sliderOptions.autoplayButtonOutput = false
    //   sliderOptions.autoplayDirection = 'backward'
    // }

    try {
      this.slider = tns(sliderOptions)

      if (this.slider) {
        this.slider.events.on('transitionEnd', this.notifyChangeFile)
      }

    } catch (error) {
      // NB: we've gotten into some unrecoverable state, reload
      window.location.reload()
    }
  },
  destroyed () {
    EventBus.$off('lightbox-mouseenter', this.onLightboxMouseEnter)
    EventBus.$off('lightbox-mouseleave', this.onLightboxMouseLeave)

    if (this.slider) {
      this.slider.events.off('transitionEnd', this.notifyChangeFile)
    }
  },
  methods: {
    findAncestor (el, cls) {
      while ((el = el.parentElement) && !el.classList.contains(cls));
      return el
    },
    rotate (array, times) {
      while (times--) {
        var temp = array.shift()
        array.push(temp)
      }

      return array
    },
    closest (target) {
      let $el = this.$el
      while ($el && $el !== target) {
        $el = $el.parentNode
      }

      return $el
    },
    onLightboxMouseEnter (event) {
      // if this is triggered by a lightbox we're
      // not in, do nothing
      if (!this.closest(event.target)) {
        return
      }

      // if the slider isn't available,
      // do nothing
      if (!this.slider) {
        return
      }

      // NB: set the caption to the image caption for the landscape
      // lightbox when we hover over it
      const info = this.slider.getInfo()
      this.notifyChangeFile(info)

      this.slider.pause()
    },
    onLightboxMouseLeave (event) {
      // if this is triggered by a lightbox we're
      // not in, do nothing
      if (!this.closest(event.target)) {
        return
      }

      // if the slider isn't available,
      // do nothing
      if (!this.slider) {
        return
      }

      this.slider.play()
    },
    notifyChangeFile (info) {
      const currentSlide = info.slideItems[info.index]
      const file = this.findFileByUrl(currentSlide.getAttribute('data-url'))
      if (!file) {
        console.error('File not found! Current slide:', currentSlide)
        return
      }

      this.$emit('file-changed', file)
    },
    findFileByUrl (url) {
      let i = this.page.files.length
      while (i--) {
        if (this.page.files[i].url === url) {
          return this.page.files[i]
        }
      }

      return null
    },
    previousSlide () {
      if (!this.slider) {
        console.error('No slider to navigate')
        return
      }

      const info = this.slider.getInfo()
      if (info.index === 1) {
        this.$emit('previous-project')
        return
      }

      this.slider.goTo('prev')
    },
    nextSlide () {
      if (!this.slider) {
        console.error('No slider to navigate')
        return
      }

      const info = this.slider.getInfo()
      if(info.index === info.slideCount) {
        this.$emit('next-project')
        return
      }

      this.slider.goTo('next')
    },
    onClickProject (event) {
      const container = this.findAncestor(this.$el, 'lightbox-project')
      const rect = container.getBoundingClientRect()

      if(event.pageX > rect.right || event.pageX < rect.left) {
        return
      }

      if(event.pageX < rect.left + (container.clientWidth / 2)) {
        this.previousSlide()
        return
      }

      this.nextSlide()
    },
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';

.project {
  height: calc(100vh - 20px) !important;
}

.project img {
  display: block;
  height: 100%;
  width: 100%;
  object-fit: contain;
  object-position: left top;
}

// .project {
//   position: absolute;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;

//   &.project-slideable {
//     position: relative;
//   }
// }

// .landscape .project .tns-slide-active {
//   // NB: kill small line at certain screen sizes at right edge
//   // of landscape box
//   margin-right: 2px;
// }
</style>



// WEBPACK FOOTER //
// client/components/Project.vue